import * as tslib_1 from "tslib";
import { SpecularCompositeMethod } from "./SpecularCompositeMethod";
/**
 * SpecularCelMethod provides a shading method to add specular cel (cartoon) shading.
 */
var SpecularCelMethod = (function (_super) {
    tslib_1.__extends(SpecularCelMethod, _super);
    /**
     * Creates a new SpecularCelMethod object.
     * @param specularCutOff The threshold at which the specular highlight should be shown.
     * @param smoothness The smoothness of the highlight edge.
     * @param baseMethod An optional specular method on which the cartoon shading is based. If ommitted, SpecularBasicMethod is used.
     */
    function SpecularCelMethod(specularCutOff, smoothness, baseMethod) {
        if (specularCutOff === void 0) { specularCutOff = 0.5; }
        if (smoothness === void 0) { smoothness = 0.1; }
        if (baseMethod === void 0) { baseMethod = null; }
        var _this = _super.call(this, baseMethod) || this;
        _this._specularCutOff = specularCutOff;
        _this._smoothness = smoothness;
        return _this;
    }
    Object.defineProperty(SpecularCelMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return SpecularCelMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpecularCelMethod.prototype, "smoothness", {
        /**
         * The smoothness of the highlight edge.
         */
        get: function () {
            return this._smoothness;
        },
        set: function (value) {
            if (this._smoothness == value)
                return;
            this._smoothness = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpecularCelMethod.prototype, "specularCutOff", {
        /**
         * The threshold at which the specular highlight should be shown.
         */
        get: function () {
            return this._specularCutOff;
        },
        set: function (value) {
            if (this._specularCutOff == value)
                return;
            this._specularCutOff = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    return SpecularCelMethod;
}(SpecularCompositeMethod));
export { SpecularCelMethod };
SpecularCelMethod.assetType = "[asset SpecularCelMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/SpecularCelMethod.js